import React from 'react';
import emptyBox from './assets/empty-list.svg';
import './styles.css';

const EmptyListPlaceholder = () => (
  <div className="EmptyListPlaceholder">
    <img src={emptyBox} alt="empty box" />
    <div className="text">Nothing to show right now</div>
  </div>
);

export default EmptyListPlaceholder;
